
<template>
  <!-- 耕雲導師永恆的懷念 -->

  <div class="firstDraft">
    <h3 class="title">{{ $t("memonyTitle") }}</h3>
    <table border="1" cellspacing="0" class="tableStyle">
      <tr v-for="(item, index) in content" :key="index">
        <td class="tableVirMidd W2">{{ index + 1 }}</td>
        <td class="tableVirMidd W9" @click="linkToDetail(item)">
          {{ item.news_title }}
        </td>
        <td class="tableVirMidd td_content f59">{{ item.news_author }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { getForeverRemembranceList } from "../../api/apis";

// import barF5 from "../../components/barF5";
export default {
  name: "",

  components: {
    // barF5
  },
  props: ["cateId", "title"],
  data() {
    return {
      content: [],
    };
  },
  methods: {
    linkToDetail(item) {
      this.$router.push({
        path: "/articleDetail",
        query: { name: "memory", id: item.id, title: this.title },
      });
    },
  },
  mounted() {
    this.cateId = this.cateId || 6;
    getForeverRemembranceList(this.cateId).then((res) => {
      this.content = res;
    });
  },
};
</script>

<style scoped>
.firstDraft {
  color: #333333;
  font-size: 0.69rem;
  padding: 0.64rem;
}
.title {
  font-size: 0.85rem;
  line-height: 1.49rem;
  margin-bottom: 0.64rem;
  font-weight: 600;
}
.tableStyle {
  width: 100%;
  text-align: center;
}

.tableVirMidd {
  display: table-cell;
  vertical-align: middle;
  line-height: 1rem;
  font-size: 0.85rem;
  text-align: left;
}

table {
  border: 1px solid #999999;
}

th {
  border: 1px solid #999999;

  height: 3rem;
}

td {
  border: solid #999999;
  border-width: 1px 1px 1px 1px;
}
.td_content {
  padding: 1rem;
  text-align: left;
  font-size: 0.85rem;
}
.f59 {
  font-size: 0.85rem;
  width: 4rem;
}
.f80 {
  font-size: 0.8rem;
}
.W2 {
  width: 2rem;
}
.W3 {
  width: 3rem;
}
.W9 {
  width: 14rem;
}
</style>